module.exports = __webpack_public_path__ + "static/img/MYYP1.2c3c54e2.png";